'use client';

import React, { useEffect, useState } from 'react';

import { useTranslations } from 'next-intl';

import {
  ManualNavigation as StyledNavigation,
  ManualStep,
  Tabs,
  Tab,
  ManualNavigationPulse,
} from '@/ui/components/Manual/manual.styled';
import { useManual } from '@/ui/components/Manual/ManualContextProvider';
import { detectMobileDevice } from '@/utils/helpers';

interface ManualNavigationProps {
  slug: string;
  showStepCounter: boolean;
  siblings: GuideData[];
  totalSteps: number;
  toggleFullscreen: () => void;
  isLoading?: boolean;
}

export function ManualNavigation({
  slug,
  showStepCounter,
  siblings,
  totalSteps,
  toggleFullscreen,
  isLoading,
}: ManualNavigationProps) {
  const t = useTranslations();
  const { activeStep, sidebar, updateSidebar, steps } = useManual();
  const [device, setDevice] = useState<{
    isTablet: boolean;
  } | null>(null);

  useEffect(() => {
    setDevice(detectMobileDevice());
  }, []);

  if (isLoading) {
    return (
      <StyledNavigation>
        <ManualNavigationPulse>
          <div className="pulse" style={{ height: '18px' }} />
        </ManualNavigationPulse>
      </StyledNavigation>
    );
  }

  return (
    <StyledNavigation>
      {showStepCounter && (
        <ManualStep>
          {t('manual-menu-step')} {activeStep + 1} {t('manual-menu-of')}{' '}
          {totalSteps} ({t('manual-menu-chapter')}{' '}
          {siblings.findIndex(item => item.slug === slug) + 1}{' '}
          {t('manual-menu-of')} {siblings.length})
        </ManualStep>
      )}
      {device && !device.isTablet && (
        <button className="fullscreen" onClick={toggleFullscreen}>
          {t('manual-menu-fullscreen-mode')}
        </button>
      )}
      <Tabs>
        {steps?.length > 0 && (
          <Tab $isActive={sidebar === 'contents'}>
            <span
              onClick={() =>
                updateSidebar(sidebar !== 'contents' ? 'contents' : null)
              }
            >
              {t('manual-menu-contents')}
            </span>
          </Tab>
        )}
        <Tab
          $orange={true}
          $mobileVisible={true}
          $isActive={sidebar === 'comments'}
        >
          <span
            onClick={() =>
              updateSidebar(sidebar !== 'comments' ? 'comments' : null)
            }
          >
            {t('manual-menu-comments')}
          </span>
        </Tab>
      </Tabs>
    </StyledNavigation>
  );
}
